import { Notice } from '@/interfaces/models/notice';
import TakeAway from '@/models/takeAway';

export default () => {
  if (Array.isArray(window.axios.defaults.transformResponse)) {
    return window.axios.defaults.transformResponse.concat((response: any): any => {
      return {
        ...response,
        notificationList: response.notificationList.map(
          (notice: Notice): Notice => ({
            ...notice,
            entity: TakeAway.createFromRequest(notice.entity),
          }),
        )
      };
    });
  }
};
